import {
    Button,
    Grid,
    Typography,
  } from "@mui/material";
  
  import { Fragment } from "react";
  import { CompanyPartHeader } from "../../../../components/PartHeader";
  
  // サブタイトルライン
  export const SubTitle = ({ totalCount, onClickRegstrationButton }) => {
    return (
      <Fragment>
        <CompanyPartHeader>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            my={1}
            >
            <Grid item xs="auto">
              <Typography fontWeight="bold" fontSize={20}>
                検索一覧
                {totalCount > 0 ? `（件数：${totalCount}）` : ""}
              </Typography>
            </Grid>
            <Grid item xs="auto">
              <Button
                variant="outlined"
                onClick={onClickRegstrationButton}
              >
                登録
              </Button>
            </Grid>
          </Grid>
        </CompanyPartHeader>
      </Fragment>
    );
  };
  
  